<template>
  <button v-if="$store.getters['popupManagerState/getLengthOfPopupOrder'] === 0"
    type="button" :class="classCst" class="mortgage-add-button" @click="showMortgageAdd">
    {{ text ? title : '+ Vytvoriť hypotéku' }}
  </button>
</template>

<script>
export default {
  name: "MortgageAddHandler",
  props: {
    rules: [Array, null],
    classCst: String,
    button: Boolean,
    text: Boolean,
    title: String,
  },
  methods: {
    showMortgageAdd () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: null,
        component: "MortgageAddPopUp",
        rules: this.rules,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mortgage-add-button {
  color: inherit;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
}

</style>
